import { QuestionForm } from './QuestionForm';
import { useCreateQuestion } from '../hooks/useCreateQuestion';

export function CreateQuestionModal({
  sectionId,
  onClose,
}: {
  sectionId: number;
  onClose: () => void;
}) {
  const { createQuestionMutation, handleSubmit } = useCreateQuestion({
    sectionId,
    onClose,
  });
  return (
    <QuestionForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      isSubmitting={createQuestionMutation.isPending}
    />
  );
}
